import React from "react";
import {
    Eye,
    MapPin,
    Mail,
    User
} from "lucide-react";
import { FullCompanyAppraiser } from "../api/ApiTypes.ts";
import { MetadataRow } from "./MetaDataRow.tsx";
import { useNavigate } from "react-router-dom";

export const CompanyAppraiserItem: React.FC<{ appraiser: FullCompanyAppraiser }> = ({ appraiser }) => {
    const navigate = useNavigate();

    const handleViewProfile = (appraiser: FullCompanyAppraiser) => {
        // Navigate to the appraiser profile page with the appraiser ID
        navigate(`/appraiser/profile/${appraiser.securityUser.id}`);
    };

    return (
        <div className="border border-slate-200 rounded-lg bg-white mb-4 shadow-sm overflow-hidden hover:shadow-md transition-shadow">
            <div className="p-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="flex-1">
                        <div className="flex items-start space-x-3">
                            <div className="p-2 bg-blue-50 rounded-md flex-shrink-0">
                                <User className="h-8 w-8 text-blue-600" />
                            </div>
                            <div>
                                <h3 className="font-medium text-lg lg:text-base text-slate-800 break-all">
                                    {appraiser.securityUser.firstName} {appraiser.securityUser.lastName}
                                </h3>
                                <p className="text-sm sm:text-base text-slate-500 mt-1">
                                    {appraiser.officeAddress}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-shrink-0">
                        <button
                            onClick={() => handleViewProfile(appraiser)}
                            className="inline-flex items-center px-3 py-2 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition-colors hover:cursor-pointer"
                        >
                            <Eye className="h-4 w-4 mr-1" />
                            View Profile
                        </button>
                    </div>
                </div>

                <div className="mt-4 pt-3 border-t border-slate-100 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
                    <MetadataRow
                        icon={<MapPin className="h-4 w-4 mr-1 text-blue-700" />}
                        label="Office:"
                        value={appraiser.officeAddress}
                    />
                    <MetadataRow
                        icon={<Mail className="h-4 w-4 mr-1 text-blue-700" />}
                        label="Email:"
                        value={appraiser.securityUser.email}
                    />
                </div>

                <div className="mt-2 flex flex-wrap gap-2">
                    {appraiser.appraiserInfo.isFhaCertified && (
                        <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700">
                            FHA Certified
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};